export default {
  common: {
    requests: 'Demandes',
    request: 'Demander',
    signUp: "S'inscrire",
    logOut: 'Déconnexion',
    seeAll: 'Voir tous',
    follow: 'Suivre',
    unfollow: 'Non suivi',
    email: 'Courriel',
    fullName: 'Nom complet',
    password: 'Mot de passe',
    next: 'Suivant',
    addNew: 'Ajouter un nouveau',
    type: 'Type',
    typeYourMessage: 'Tapez votre message',
    yourMessage: 'Votre message',
    message: 'Message',
    shoutOut: 'Shoutout',
    story: 'Histoire',
    chat: 'Chatte',
    featureComingSoon: 'This feature is coming soon!',
    okay: 'Okay',
    send: 'Envoyer',
    delete: 'Supprimer',
    cancel: 'Annuler',
    search: 'Recherche',
    back: 'Retour',
    goToHome: "Aller à l'accueil",
    addShoutout: 'Ajouter un commentaire',
    player: 'Joueur',
    text: 'Texte',
    video: 'Vidéo',
    comment: 'Commentaire',
    team: "L'équipe",
    country: 'Pays',
    city: 'Ville',
    userName: "Nom d'utilisateur",
    following: 'Suivant',
    followers: 'Suiveurs',
    referals: 'Référentiels',
    athletes: 'Athlètes',
    shoutouts: 'Salutations',
    showMore: 'Afficher plus',
    showLess: 'Montrer moins',
    sport: 'Le sport',
    position: 'Position',
    league: 'Ligue',
    info: 'Info',
    repost: 'Repost',
    share: 'Partager',
    confirmed: 'Confirmé',
    refused: 'Refus',
    pending: 'En attente',
    canceled: 'Annulé',
    trending: 'Tendance',
    latest: 'Dernières nouvelles',
    noData: 'Pas de données',
    from: 'À partir de',
    to: 'à',
    settings: 'Paramètres',
    areYouSure: 'Êtes-vous sûr',
    profile: 'Profil',
    accept: 'Accepter',
    refuse: 'Refuser tout',
    missing: 'Disparu',
    select: 'Sélectionner',
    currency: 'Monnaie',
    zipCode: 'Code postal',
    goBack: 'Retourner',
    done: 'Terminé',
    remove: 'Retirer',
    date: 'Date',
    description: 'Description',
    amount: 'Montant',
    upload: 'Télécharger',
    getApp: 'Obtenir APP',
    today: "Aujourd'hui",
    yesterday: 'Hier',
    tomorrow: 'Demain',
    confirm: 'Confirmer',
    confirmAll: 'Confirmer tout',
    login: 'Connexion',
    ad: 'AD',
    aboutUs: 'A propos de nous',
    fan: 'Fan',
    athlete: 'Athlète',
    stats: 'Statistiques',
    posts: 'Postes',
    store: 'Magasin',
    or: 'Ou',
    shoutout: 'Shoutout',
    proceed: 'Procéder',
    required: 'Requis',
    dismiss: 'Rejeter',
    save: 'Enregistrer',
    discard: 'Rejeter',
    submit: 'Soumettre',
    live: 'Vivre',
    openInbox: 'Ouvrir la boîte de réception',
    home: 'Accueil',
    searchDotDotDot: 'Recherche...',
    reply: 'Répondre',
    subscribers: 'Les abonnés',
    subscribed: 'Abonnés',
    subscribe: 'Abonnez-vous !',
    unsubscribe: 'Se désabonner',
    fans: 'Les fans',
    teams: 'Les équipes',
    setup: 'Mise en place',
    feed: 'Alimentation',
    messages: 'Messages',
    earlier: 'Plus tôt',
    apply: 'Appliquer',
    oneOnOnes: 'Prochains tête-à-tête',
    sort: 'Trier',
    comingSoon: 'À venir',
    goLive: 'Passez en direct',
    total: 'Coût total : ',
    pay: 'Payez {{amount}}',
    free: 'gratuit',
    location: 'Localisation',
    countries: 'Pays',
    more: 'plus',
    less: 'moins',
    block: 'Bloc',
    unblock: 'Débloquer',
    privacyPolicy: 'Politique de confidentialité',
    termsAndConditions: "Conditions générales d'utilisation",
    createNew: 'Créer un nouveau',
    game: 'Jeu',
    unlock: 'Déverrouiller',
    post: 'Poste',
    uploadFile: 'Télécharger le fichier',
    checkIn: 'Enregistrement',
    unregisteredType: "Le type n'est pas enregistré.",
    required: 'Requis',
    create: 'Créer',
    reply: 'Répondre'
  },
  sports: {
    americanFootball: 'Football américain',
    baseball: 'Baseball',
    basketball: 'Basket-ball',
    boxing: 'Boxe',
    cricket: 'Criquet',
    soccer: 'Football',
    mma: 'MMA',
    race: 'Conduite de voiture de course',
    tennis: 'Tennis',
    carRace: 'Conduite de voiture de course',
    acrobatics: 'Acrobaties',
    airSports: 'Sports aériens',
    archery: "Tir à l'arc",
    combatSports: 'Sports de combat',
    cycling: 'Cyclisme',
    cueSports: 'Sports de queue',
    equestrianSports: 'Sports équestres',
    golf: 'Le golf',
    handball: 'Handball',
    iceSports: 'Sports de glace',
    lacrosse: 'Lacrosse',
    polo: 'Polo',
    weightlifting: 'Musculation',
    rowing: 'Aviron',
    softball: 'Balle molle',
    rugby: 'Le rugby',
    volleyball: 'Volley-ball',
    coachingMentoring: 'Le coaching mentorat',
    figureSkating: 'Patinage artistique',
    formula1: 'Formule 1',
    gymnastics: 'Gymnastique',
    hockey: 'Le hockey',
    kickboxing: 'Kickboxing',
    motorSports: 'Sports motorisés',
    muayThai: 'Muay Thaï',
    olympics: 'Jeux olympiques',
    poleSports: 'Pôle Sports',
    sportsInfluencer: 'Influenceur sportif',
    swimming: 'Natation',
    trackField: 'Piste de course',
    visualArtist: 'Artiste visuel',
    wheelchairRugby: 'Rugby en fauteuil roulant',
    wrestling: 'Lutte',
    iceHockey: 'Hockey sur glace',
    alpineSkiing: 'Ski alpin',
    flagFootball: 'Flag Football',
    climbing: 'Escalade',
    badminton: 'Badminton',
    motorcycleRacing: 'Courses de motos'
  },
  levels: {
    interested: 'Intéressé',
    beginner: 'Débutant',
    amateur: 'Amateur',
    intermediate: 'Intermédiaire',
    expert: 'Expert',
    retired: 'Retraité'
  },
  auth: {
    signUpFacebook: "S'inscrire sur Facebook",
    signUpGoogle: "S'inscrire avec Google",
    signUpPaypal: "S'inscrire avec PayPal",
    forgottenPassword: 'Vous avez oublié votre mot de passe ?',
    logInFacebook: 'Se connecter avec Facebook',
    logInGoogle: 'Se connecter avec Google',
    logInPaypal: 'Se connecter avec PayPal',
    dontHaveAccount: "Vous n'avez pas de compte ?",
    mustContain8Characters: 'Doit contenir au moins 8 caractères.',
    alreadyHaveAccount: 'Vous avez déjà un compte ?',
    passwordReset: 'Réinitialisation du mot de passe',
    resetInstructions:
      "Saisissez l'adresse électronique associée à votre compte et nous vous enverrons les instructions de récupération du mot de passe.",
    sendRecoveryEmail: "Envoi d'un courriel de récupération",
    backTo: 'Retour à',
    logIn: 'Se connecter',
    checkEmail: 'Vérifiez votre adresse e-mail',
    noAccount: "Il n'y a pas de compte associé",
    pleaseTryAnother: 'Veuillez essayer une autre adresse.',
    tryAnother: 'Essayez un autre e-mail',
    emailSent: 'E-mail de récupération envoyé',
    checkEmailInstructions:
      'Vérifiez votre boîte de réception (et vos dossiers de spam) pour trouver et suivre les instructions de réinitialisation de votre mot de passe.',
    createNewPassword: 'Créer un nouveau mot de passe',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    validateYourEmail: 'Validez votre email',
    validateEmailInstructions:
      'Nous avons besoin que vous validiez votre email pour activer votre nouveau compte P4P.',
    confirmEmail: "Confirmer l'email",
    validationEmailSent: 'Envoi du courriel de validation',
    checkInboxToValidateEmail:
      'Vérifiez votre boîte de réception (et vos dossiers de courrier indésirable) pour trouver et suivre les instructions de validation de votre courrier électronique.',
    getTheApp: "Obtenir l'application",
    accountLocked: 'Votre compte est bloqué',
    accountLockedDesc:
      "Nous veillons à la sécurité et avons verrouillé votre compte en raison d'un trop grand nombre de tentatives avec des informations d'identification erronées. Veuillez consulter votre boîte de réception pour réinitialiser votre mot de passe.",
    checkInbox: 'Vérifier ma boîte de réception',
    youAcceptTerms:
      'En vous inscrivant ou en vous connectant, vous acceptez nos conditions générales et notre politique de confidentialité.',
    logInApple: 'Se connecter avec Apple',
    signUpApple: "S'inscrire auprès d'Apple"
  },
  messages: {
    newMessages: 'Nouveaux messages',
    newGroup: 'Nouveau groupe',
    favorites: 'Favoris',
    favoritesAtTop: 'Favoris en haut de la page',
    favoritesOnly: 'Favoris uniquement',
    excludeHidden: 'Exclure les éléments cachés',
    showHidden: 'Montrer caché',
    hiddenChats: 'Discussions cachées',
    message: 'Message',
    addChat: 'Ajouter un chat',
    searchFriends: "Recherche d'amis",
    createdGroup: '{{group}} a créé ce groupe',
    totalMessageSingular: '1 Nouveau message',
    totalMessages: '{{totalMessageCount}} Nouveaux messages',
    noChats: "Aucun chat n'est disponible.",
    noChatSelected: "Aucun chat n'a été sélectionné.",
    messageDotDotDot: 'Message...',
    noChatYet: 'Pas encore de chat ici...',
    searchFriendsGroups: 'Rechercher des amis ou des groupes...',
    selectFriend: 'Sélectionner un ami',
    groupChatName: 'Nom du groupe de discussion',
    startChat: 'Démarrer le chat',
    youNeedSub: 'Vous devez vous abonner à {{name}} pour envoyer un message',
    youBlocked: 'Vous avez bloqué cet utilisateur'
  },
  home: {
    latestPosts: 'Derniers messages',
    confirmed: 'Confirmé',
    playazRunsSafeEnvironment: 'Playaz offre un environnement sûr',
    connectionsConverstationsFollowedAthletes:
      'Des connexions avec des personnes partageant les mêmes idées pour avoir des conversations, des réunions de groupe et apprendre des athlètes que vous suivez.',
    myPosts: 'Mes messages',
    accountsToFollow: 'Comptes à suivre',
    comingUp: 'À venir',
    gloriousWinners: 'Les grands vainqueurs',
    todaysGames: "Jeux d'aujourd'hui",
    athleteHighlights: "Points forts de l'athlète",
    fanHighlights: 'Les points forts des supporters',
    todaysMatches: "Les matchs d'aujourd'hui"
  },
  add: {
    followers: 'Suiveurs',
    subscribers: 'Les abonnés',
    onlyMe: 'Seulement moi',
    photoVideo: 'Photos/Vidéos',
    tag: 'Taguer',
    editMedia: 'Editer les médias',
    tapCrop: 'Tapez sur une image pour la recadrer.',
    gallery: 'Galerie',
    addMultiple: 'Ajouter plusieurs',
    shoutOutTo: 'Un coup de chapeau à',
    whereItHappens: 'Où cela se passe-t-il ?',
    shouldAcceptTerms: 'Vous devez accepter les conditions générales',
    summary: 'Résumé',
    total: 'Coût total : ',
    iAcceptTerms:
      "Conformément aux conditions générales, j'accepte que le montant indiqué ci-dessus me soit facturé lors de la confirmation de l'athlète.",
    post: 'Poste',
    enterYoutubeLink: 'Entrer le lien Youtube',
    tagFriends: 'Tag amis',
    shareWith: 'Partager avec',
    everyone: 'Tout le monde',
    peopleFollowBack: 'Seulement les personnes que je suis en retour',
    linkToVideo: 'Lien vers la vidéo',
    swipeRightPurchase: 'Passer à droite pour acheter',
    uploadMedia: 'Télécharger les médias',
    shareLink: 'Partager le lien',
    correctYoutubeLink: 'Veuillez ajouter un lien Youtube correct.',
    writeCaption: 'Rédiger une légende',
    selectionsWillRemove:
      "Vous ne pouvez publier qu'une seule vidéo, les autres sélections seront supprimées. Poursuivre ?",
    selectVideo: 'Sélectionner une vidéo',
    onlySingleVideo: "Pour l'instant, vous ne pouvez publier qu'une seule vidéo.",
    upToAMinutes: 'La durée maximale de la vidéo est de 1 minute.',
    text: 'Texte',
    video: 'Vidéo',
    tagPeople: 'Taguer des personnes',
    enterLink: 'Saisir le lien',
    linkToOriginalPost: "Lien vers l'article original",
    pasteForPreview: "Collez le lien pour voir l'aperçu de l'article",
    createPost: 'Créer un poste...',
    recent: 'Récents',
    noUserFound: "Aucun résultat n'a été trouvé avec les critères correspondants",
    searchResults: 'Résultats de la recherche',
    storyPublished: 'Article publié !',
    live: 'Vivre',
    shoutout: 'Shoutout',
    addPhotosAndVideos: 'Ajouter des photos et des vidéos',
    addLocation: 'Ajouter un lieu',
    onlyForSubscribers: 'Uniquement pour les abonnés',
    photosAndVideos: 'Photos et vidéos',
    selectUpTo10: "Sélectionner jusqu'à 10",
    suggested: 'Suggéré',
    shoutoutTo: "C'est parti !",
    createShoutout: 'Créer un Shoutout',
    newShoutout: 'Nouveau Shoutout',
    tapOrHold: 'Touchez pour une photo, maintenez pour une vidéo',
    tapGoLive: 'Tapez sur pour passer en direct',
    addNewPost: 'Ajouter un nouveau message',
    addNewShoutout: 'Ajouter un nouveau cri de ralliement',
    fileFormats: 'Formats de fichiers JPEG, PNG, MP4, WebM ou Ogg',
    create: 'Créer',
    correctLink: 'Veuillez ajouter un lien correct.',
    teamOrPlayer: 'Équipe ou joueur',
    createNewShoutout: 'Créer un nouveau salut',
    createNewPost: 'Créer une nouvelle publication'
  },
  browse: {
    trySearchAthlete: 'Essayez de rechercher un athlète, une équipe ou un hashtag.',
    basedYourPreferences:
      'En fonction de vos préférences, voici quelques athlètes et fans que vous aimeriez suivre.',
    erlingHaaland: 'Erling Haaland',
    parisSaintGermain: 'Paris Saint-Germain',
    trendingPosts: 'Articles en vogue',
    chooseSportAndFavoriteTeam:
      "Choisissez les sports et sélectionnez votre équipe d'athlètes préférée pour vous tenir au courant.",
    trendingTeams: 'Équipes en vogue',
    seeTeamsYourFellow: 'Découvrez les équipes que vos amis fans et athlètes suivent en ce moment.',
    atalanta: 'Atalante',
    serieaFootballClub: 'Serie A Club de football',
    browse: 'Parcourir',
    athletesOnPlatform: 'Athlètes sur P4P',
    fansOnPlatform: 'Les fans de P4P',
    upcomingEvents: 'Événements à venir',
    eventsComingUpYourFavorite:
      'Événements à venir en fonction de vos sports, équipes et athlètes préférés.',
    superBantamweight: 'Super Bantamweight',
    tiffanyVanSoestAlinePereira: 'Tiffany van Soest - Aline Pereira',
    chicagoVenue: 'Chicago, Chicago Venue',
    suggestedAthletes: 'Athlètes suggérés',
    suggestedFans: 'Suggérés',
    suggestedAccounts: 'Comptes suggérés',
    newAppHasArrived: 'Notre nouvelle application est arrivée !',
    newAppDesc:
      "Nous avons enrichi votre expérience P4P grâce à vos commentaires. Appréciez l'APP mise à jour et restez à l'écoute des prochaines mises à jour.",
    seeTheApp: "Voir l'APP",
    postCountSingular: '1 poste',
    postCountPlural: '{{count}} posts',
    recent: 'Récents',
    top: 'Haut de page',
    athletes: 'Athlètes',
    teams: 'Les équipes',
    tags: 'Tags',
    fans: 'Les fans',
    trendingShoutouts: 'Les coups de cœur de la tendance',
    goBrowse: 'Parcourir',
    follower: 'suiveur',
    followers: 'suiveurs',
    todaysGames: "Jeux d'aujourd'hui",
    trendingAthletes: 'Athlètes en vogue',
    trendingFans: 'Les fans en vogue',
    allAthletes: 'Tous les athlètes',
    allFans: 'Tous les fans',
    sortBy: 'Trier par',
    name: 'Nom',
    popularity: 'Popularité',
    recentlyRegistered: 'Récemment enregistré',
    filterByConnection: 'Filtrer par connexion',
    showAll: 'Afficher tout',
    showOnlyConnect: 'Afficher uniquement les athlètes que vous pouvez connecter',
    teamsOnPlatform: 'Les équipes sur le P4P',
    allTeams: 'Toutes les équipes',
    todaysMatches: "Les matchs d'aujourd'hui"
  },
  chat: {
    muteNotifications: 'Désactiver les notifications',
    removeFavorites: 'Supprimer des favoris',
    addFavorites: 'Ajouter aux favoris',
    clearChatHistory: "Effacer l'historique des chats",
    youCannotAction: 'Vous ne pouvez pas annuler cette action.',
    deleteConversationWith: 'Supprimer la conversation avec ',
    deleteConversation: 'Supprimer une conversation',
    unhideChat: 'Dévoiler le chat',
    hideChat: 'Cacher le chat',
    clearHistory: "Effacer l'historique",
    noResults: 'Aucun résultat...',
    noMessagesYet: "Aucun message pour l'instant...",
    returnChat: 'Retourner au chat',
    searchMessages: 'Recherche de messages...',
    clearConfirmation: 'Êtes-vous sûr de vouloir effacer cette discussion ?',
    deleteConfirmation: 'Êtes-vous sûr de vouloir supprimer ce chat ?',
    block: 'Bloc',
    disableSound: 'Désactiver le son',
    muteNotificationsFor: 'Désactiver les notifications pour...',
    thirtyMinutes: '30 minutes',
    oneHour: '1 heure',
    oneDay: '1 jour',
    oneWeek: '1 semaine',
    oneMonth: '1 mois',
    muteForever: 'Muet pour toujours'
  },
  comments: {
    succesfullyReactedPost: 'A réagi avec succès à ce message.',
    beFirstReaction: 'Soyez le premier à réagir',
    comments: 'Commentaires',
    noComments: 'Pas de commentaires',
    comment: 'Commentaire'
  },
  connect: {
    endOneOnOneWith: 'Finir en tête-à-tête avec ',
    youWontGoBackCall: 'Vous ne pourrez pas revenir sur cet appel payant.',
    sayGoodBye: 'Dites au revoir à ',
    timeToWrapUp: 'Il est temps de conclure',
    oneOnOneCall: 'Appel individuelle',
    setupConnect: 'Configurer une connexion individuelle'
  },
  connectConfirmations: {
    cancelOneOnOne: 'Annuler en tête-à-tête',
    unfortunatelyCanceled:
      'Malheureusement, votre contact en tête-à-tête avec {{name}} a été annulé.',
    timeToStart: 'Il est temps de commencer vos 15 minutes réservées en tête-à-tête avec {{name}}',
    swipeCancel: 'Balayez vers la droite pour annuler la connexion',
    wantCancelOneOnOne: 'Voulez-vous annuler le tête-à-tête',
    youWillPay:
      "Cette opération ne peut être annulée et vous devrez payer des frais d'annulation ({{amount}}).",
    fanWillGet:
      'Cela ne peut pas être annulé et le fan recevra un remboursement de 100 % ( {{amount}} )',
    swipeRightStart: 'Balayez vers la droite pour commencer à vous connecter',
    oneOnOneConnectEnded: 'Connexion individuelle terminée',
    '15minCall':
      'Votre appel de 15 minutes avec {{name}} , et nous espérons que vous avez eu une conversation passionnante avec votre athlète préféré.',
    bookAnotherOneOnOne: 'Réservez un autre tête-à-tête',
    refuseOneOnOne: 'Refuser le tête-à-tête',
    wantRefuseOneOnOne: 'Voulez-vous refuser le tête-à-tête avec {{name}}',
    swipeRightRefuseConnect: 'Passer à droite pour refuser la connexion',
    '15minCallWithAthlete':
      'Votre appel de 15 minutes avec {{name}} , et nous espérons que vous avez eu une conversation passionnante avec votre athlète préféré.',
    waitingInLobby: "Attente dans le hall d'entrée...",
    pleaseWaitUser:
      'Veuillez attendre que votre tête-à-tête avec <strong> {{name}} <\/strong> commence.',
    refusedOneOnOneConnect: "Refus d'une connexion individuelle",
    callSettings: "Paramètres d'appel :"
  },
  settings: {
    referAnAthlete: 'Recommander un athlète',
    upgradePlan: 'Plan de mise à niveau',
    settings: 'Paramètres',
    changePassword: 'Modifier le mot de passe',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe',
    privacyAndSecurity: 'Vie privée et sécurité',
    profilePrivacySettings: 'Paramètres de confidentialité du profil',
    whoCanView: 'Qui peut consulter votre page de profil ?',
    whoCanViewInfo: 'Qui peut consulter l\'onglet "Informations" de votre page de profil ?',
    whoCanViewBasicInfo: 'Qui peut consulter vos informations de base ?',
    whoCanViewLocation: 'Qui peut voir votre position ?',
    whoCanViewActivities: "Qui peut consulter votre section d'activités sur votre page de profil ?",
    whoCanShare: 'Qui peut partager un message sur votre mur ?',
    whoCanViewFriends: 'Qui peut consulter la liste de vos amis ?',
    whoCanSendFriends: "Qui peut m'envoyer une demande d'amitié ?",
    whoCanSendMessage: 'Qui peut vous envoyer un message ?',
    whoCanViewPhotos: 'Qui peut voir les photos sur votre page de profil ?',
    whoCanPokes: 'Qui peut envoyer des pokes ?',
    whoCanViewViewed: 'Qui peut voir qui a récemment consulté votre profil ?',
    whoCanTag: "Qui peut m'étiqueter dans des contextes écrits ?",
    whoCanSeeDateOfBirth: 'Qui peut consulter votre date de naissance ?',
    allowSharing: 'Permettre le partage à partir de',
    allowMentions: 'Autoriser les mentions de',
    allowTags: 'Autoriser les balises de',
    avilabilityPeriod: 'Période de disponibilité',
    pleaseShare:
      'Veuillez indiquer vos attentes en matière de revenus mensuels. Les fans ne verront pas cela dans votre profil.',
    customPeriod: 'Période personnalisée...',
    from: 'À partir de',
    to: 'à',
    selectStart: 'Sélectionner la date de début',
    selectEnd: 'Sélectionner la date de fin',
    total: 'Coût total : ',
    pendingRequest: 'Demandes en cours',
    invalid: 'invalide',
    today: "Aujourd'hui",
    months: 'Mois',
    weeks: 'Semaines',
    setAvailability: 'Définir la disponibilité',
    fansWillOnly: 'Les fans ne pourront réserver un tête-à-tête que dans les créneaux disponibles.',
    period: 'Période',
    dayOfTheWeek: 'Jour de la semaine',
    daily: 'Quotidien',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois-ci',
    availableTime: 'Temps disponible',
    time: "L'heure",
    timeBetween: 'Délai entre les connexions',
    breakDuration: 'Durée de la pause',
    setAvailableTime: 'Régler le temps disponible sur',
    chooseATime:
      'Choisissez un moment de la journée où vous souhaitez obtenir des demandes individuelles pour',
    weekDays: 'Jours de la semaine',
    weekends: 'Fins de semaine',
    oneOnOneConnect: 'Connexion individuelle',
    save: 'Enregistrer',
    search: 'Recherche',
    subscriptions: 'Abonnements',
    emailNotifications: 'Notifications par courrier électronique',
    languageAndCurrency: 'Langue et monnaie',
    theme: 'Thème',
    billing: 'Facturation',
    accessBilling: 'Accéder aux informations de facturation',
    logOut: 'Déconnexion',
    countryCode: 'Code pays',
    selectCountry: 'Sélectionner un pays',
    passwordChangeSuccessful: 'Vous avez mis à jour votre mot de passe avec succès.',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    enableEmailNotifications: 'Activer les notifications par courrier électronique',
    newComments: 'Nouveaux commentaires',
    newTags: 'newTags',
    newSubscriptions: 'Nouveaux abonnements',
    newFriends: 'Nouveaux amis',
    friendRequests: "Demandes d'amis",
    notificationForLikes: 'Notification pour "Likes"',
    newMessages: 'Nouveaux messages',
    photosNotifications: 'Notifications de photos',
    language: 'Langue',
    currency: 'Monnaie',
    anyone: 'Tout le monde',
    community: 'Communauté',
    friendsOnly: 'Réservé aux amis',
    noOne: 'Personne',
    onlyAvailableViaApp: "Uniquement disponible via l'APP mobile",
    darkMode: 'Mode sombre',
    contentPrivacySettings: 'Paramètres de confidentialité du contenu',
    setAvailableTimeTo: 'Régler le temps disponible sur',
    chooseATimeTo:
      'Choisissez un moment de la journée où vous souhaitez obtenir des demandes individuelles pour',
    removeAccount: 'Supprimer le compte',
    accountPrivacy: 'Compte'
  },
  scheduleConnect: {
    '15minutesCall': 'Appel de 15 minutes',
    thereIsNo: "Il n'y a pas de disponibilité pour cette date.",
    selectTime: "Sélectionner l'heure",
    bookOneOnOne: 'Réserver un rendez-vous individuel',
    youAlreadyHave: 'Vous avez déjà un lien avec cet athlète.',
    scheduleAlreadyExist: 'Le programme existe déjà',
    ad: 'AD',
    nextAvailableSlot: 'Prochain créneau disponible',
    noScheduleFound: "Pas d'horaire trouvé",
    thisUserHasnt: "Cet utilisateur n'a pas encore défini son horaire. Veuillez revenir plus tard.",
    schedule: 'Calendrier',
    today: "Aujourd'hui",
    tomorrow: 'Demain',
    weeks: 'Semaines',
    seeCalendar: 'Voir le calendrier',
    dateAndTime: 'Date et heure',
    edit: 'Editer',
    total: 'Coût total : ',
    asPerTheTerms:
      "Conformément aux conditions générales, j'accepte que le montant indiqué ci-dessus me soit facturé lors de la confirmation de l'athlète.",
    sendRequest: 'Envoyer la demande',
    oneOnOneRequest: "Envoi d'une demande individuelle",
    afterTheAthleteAccepts:
      "Une fois que l'athlète a accepté votre demande, vous recevrez une notification et verrez le tête-à-tête en attente sur le tableau de bord.",
    goToDashboard: 'Aller au tableau de bord',
    bookOtherOneOnOne: "Réserver d'autres rencontres individuelles",
    proceed: 'Procéder',
    searcAthletes: "Recherche d'athlètes",
    notVerified: "Ce profil n'est pas un athlète vérifié.",
    bookOneOnOneTeam: 'Booking a Face2Face? Please select your favorite athlete. Thank you!',
    noBooked: "Vous n'avez pas encore réservé d'entretiens individuels",
    bookedYet: 'Avez-vous déjà réservé un entretien individuel ?',
    selectDay: 'Sélectionner le jour',
    nextOneOnOnes: 'Prochains tête-à-tête',
    noResults:
      "Tous nos athlètes ont un programme chargé. Des disponibilités s'ouvrent régulièrement, n'hésitez donc pas à revenir plus tard."
  },
  connectsDashboard: {
    byFan: 'PAR FAN',
    byAthlete: 'PAR ATHLÈTE',
    pending: 'En attente',
    confirmed: 'Confirmé',
    rejected: 'Rejeté',
    timeBooked: 'Temps réservé',
    refuseOneOnOneConnect: 'Refuser toute connexion individuelle pour ',
    refuseAll: 'Refuser tout',
    oneOnOneConnect: 'Connexion individuelle',
    bookAgain: 'Réserver à nouveau'
  },
  dashboard: {
    monthlyTarget: 'Objectif mensuel',
    setMonthlyRevenueTarget: "Vous n'avez pas encore fixé votre objectif de revenu mensuel.",
    useAthleteRefferalCodes:
      "Utiliser les codes de parrainage des athlètes pour développer l'équipe",
    setupRateAndAvailability:
      'Fixer le taux et la disponibilité pour obtenir des demandes individuelles.',
    shoutouts: 'Salutations',
    vipConnect: 'VIP Connects !',
    week: 'Semaine',
    month: 'Mois',
    year: 'Année',
    all: 'Tous',
    custom: 'Sur mesure...',
    total: 'Coût total : ',
    dashboard: 'Tableau de bord',
    referrals: 'Renvois',
    income: 'Revenu',
    users: 'Utilisateurs',
    subscribed: 'Abonnés',
    progress: 'Progrès',
    followers: 'Suiveurs',
    advertising: 'Publicité',
    views: 'Points de vue',
    number: 'Nombre',
    athleteEmail: "Courriel de l'athlète",
    meetings: 'Réunions',
    itemsSold: 'Articles vendus',
    store: 'Magasin',
    editMonthlyTarget: "Modifier l'objectif mensuel",
    inviteToGrow: "Tapez email pour envoyer une invitation à développer l'équipe.",
    inviteAthletes: 'Inviter les athlètes',
    follower: 'Suiveurs'
  },
  editProfile: {
    sport: 'Le sport',
    selectSuport: 'Sélectionner le sport',
    favoriteTeam: 'Équipe préférée',
    selectTeam: "Sélectionner l'équipe",
    favoritePlayer: 'Joueur préféré',
    selectPlayer: 'Sélectionner un joueur',
    addMoreSport: 'Ajouter plus de sport',
    editProfile: 'Modifier le profil',
    dateOfBirth: 'Date de naissance',
    bio: 'Bio',
    mySport: 'Mon sport',
    mySports: 'Mes sports',
    position: 'Position',
    selectPosition: 'Sélectionner la position',
    level: 'Niveau',
    selectLevel: 'Sélectionner le niveau',
    personalInformation: 'Informations personnelles',
    myGender: 'Mon sexe',
    female: 'Femelle',
    male: 'Mâle',
    other: 'Autre',
    imFrom: 'Je suis originaire de',
    yourPhoneNumber: 'Votre numéro de téléphone'
  },
  profile: {
    wantToConnect: 'Vous souhaitez prendre contact en personne ?',
    favoriteSports: 'Sports préférés',
    favoriteAthlete: 'Athlète préféré',
    referAndReward: 'Soyez récompensé en parrainant un athlète',
    invitePeople: 'Inviter des personnes',
    earnMoreReferralFees:
      "Gagnez plus d'honoraires de parrainage en invitant des athlètes autour de vous",
    inviteAthleteFan: 'Inviter les athlètes et les supporters',
    typeEmailToInvite: "Tapez email pour envoyer une invitation à développer l'équipe.",
    athleteEmail: "Courriel de l'athlète",
    doesntExists: "Cet utilisateur n'existe pas.",
    latestShoutouts: 'Derniers cris',
    mySports: 'Mes sports',
    myEquipment: 'Mon équipement',
    relatedProducts: 'Produits apparentés',
    bidForEquipment: 'Offre pour mon équipement',
    goToAppSettings: "Aller dans les paramètres de l'APP",
    recentShoutouts: 'Récents témoignages',
    recentUpdates: 'Mises à jour récentes',
    trendingPosts: 'Les fans en vogue',
    following: 'Suivant',
    userNotFound: 'Utilisateur @{{username}} introuvable',
    searchFriendsAndFollowers: "Recherche d'amis et de suiveurs",
    noUpdatesYet: "{{name}} n'a pas encore de mises à jour",
    noPostsYet: '{{name}} n’a pas encore posté',
    followToKnowFirst:
      'Suivez {{name}} pour être le premier à connaître les mises à jour comme les podcasts ou la diffusion en direct.',
    encourage: "N'hésitez pas à leur envoyer un message pour les encourager.",
    threeMonthsAccess: "Vous disposez de trois mois d'accès illimité aux portes fermées",
    enjoyFreeAccess: 'Profitez du contenu exclusif des athlètes.',
    repostHeader:
      '<strong> {{owner}} <\/strong> a partagé la publication <strong> {{originalOwner}} <\/strong>',
    nowFollowing: 'Maintenant, je suis {{name}}',
    sureToRemove:
      'Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.',
    getUnlimited: 'Obtenir un contenu illimité',
    getUnlimitedDesc:
      'Abonnez-vous à votre athlète préféré pour recevoir des informations exclusives.',
    verifiedAthlete: 'Athlète vérifié'
  },
  notifications: {
    notifications: 'Notifications',
    comingUpConnect: 'Rendez-vous en tête-à-tête avec {{sender}} dans cinq minutes',
    connectRequest: 'Demande individuelle de {{sender}}',
    connectStatus: '{{status}} en tête-à-tête avec {{sender}}',
    connectStarting:
      'Il est temps de commencer votre rendez-vous de 15 minutes en tête-à-tête avec {{sender}}.',
    commentedToPost: 'a commenté votre article',
    commentedToSportChat: '<strong>{{sender}}</strong> \ncommented on your sport chat',
    reactedToPost: 'a réagi à votre message',
    reactedToShoutout: "a réagi à votre appel à l'aide",
    amountReactedToPost: '{{amount}} personnes ont réagi à votre message',
    aNewShoutout: 'Vous avez un nouveau "shoutout',
    newShoutouts: "Vous avez {{amount}} nouveaux messages d'encouragement",
    shoutoutReaction: '{{sender}} a réagi à votre shoutout',
    startedFollowing: '{{sender}} a commencé à vous suivre',
    amountStartedFollowing: 'Les utilisateurs de {{amount}} ont commencé à vous suivre',
    newSub: 'Vous avez un nouvel abonné',
    newSubs: 'Vous avez {{amount}} nouveaux abonnés',
    newRequests: '{{amount}} nouvelles demandes individuelles',
    newFollower: 'vous a suivi',
    taggedInPost: '<strong>{{sender}}<\/strong> \nvous a marqué dans son message',
    mentionedInPost: '<strong>{{sender}}<\/strong> \nvous a mentionné dans son message',
    commentTagged: '<strong>{{sender}}<\/strong> \nvous a marqué dans son commentaire',
    p4pMonetizingYourBrand: 'P4P est en train de monétiser votre marque!',
    fanRequestingShoutout: 'Un fan demande un salut.',
    view: 'Voir',
    congratulations: 'Félicitations!',
    yourFavoriteAthleteCompletedYourRequest: 'Votre athlète préféré a complété votre salutation.',
    sorryFavoriteAthleteCurrentlyUnavailable:
      "Désolé, votre athlète préféré n'est actuellement pas disponible. Veuillez réessayer plus tard ou sélectionner un autre joueur.",
    sportChatCommentTagged: '<strong>{{sender}}</strong> \ntagged you in their sport chat comment',
    startedSubscribing: '<strong>{{sender}}<\/strong> \nest maintenant abonné à vous'
  },
  repost: {
    tagFriends: 'Tag amis',
    repost: 'Republier',
    create: 'Créer',
    yourComment: 'Votre commentaire',
    shareWith: 'Partager avec',
    everyone: 'Tout le monde',
    OnlyPeopleIFollowBack: 'Seulement les personnes que je suis en retour'
  },
  onBoarding: {
    everybody: 'TOUT LE MONDE',
    plays: 'JEUX',
    better: 'MIEUX',
    together: 'ENSEMBLE.',
    favoriteSports: 'Sports préférés',
    chooseSports:
      "Choisissez les sports et sélectionnez votre équipe d'athlètes préférée pour vous tenir au courant.",
    selectSport: 'Sélectionner un sport',
    sport: 'Le sport',
    favoriteTeam: 'Équipe préférée',
    selectTeam: "Sélectionner l'équipe",
    favoritePlayer: 'Joueur préféré',
    selectPlayer: 'Sélectionner un joueur',
    addMoreSport: 'Ajouter plus de sport',
    getStarted: 'Commencer',
    youreAlmostThere: 'Vous y êtes presque',
    tellUsAboutYourself:
      'Parlez-nous de vous pour recevoir les flux et les mises à jour les plus pertinents.',
    imFrom: 'Je suis originaire de',
    yourPhoneNumber: 'Votre numéro de téléphone',
    dateOfBirth: 'Date de naissance',
    monthlyRevenueTarget: 'Objectif de recettes mensuelles',
    pleaseShareYour:
      'Veuillez indiquer vos attentes en matière de revenus mensuels. Les fans ne verront pas cela dans votre profil.',
    next: 'Suivant',
    skipThisStep: 'Sauter cette étape',
    yourSports: 'Vos sports',
    chooseASport: 'Choisissez un sport et une position.',
    mySport: 'Mon sport',
    position: 'Position',
    selectPosition: 'Sélectionner la position',
    addSecondarySport: 'Ajouter un sport secondaire',
    chooseSportsYou: 'Choisissez des sports qui vous intéressent.',
    skipAndGet: 'Sauter et commencer',
    connectDirectlyWith: "Connectez-vous directement avec vos athlètes préférés et d'autres fans.",
    monetizeYourBrand: 'Monétisez votre marque en créant un univers unique avec vos fans.',
    chooseAUsername: "Choisir un nom d'utilisateur",
    referralCodeOptional: 'Code de référence (facultatif)',
    backTo: 'Retour à',
    logIn: 'Se connecter',
    imAFan: 'Je suis fan',
    imAnAthlete: 'Je suis un athlète',
    createAnAccount: 'Créer un compte',
    searchTeams: 'Équipes de recherche'
  },
  shoutout: {
    comingSoon: 'Shoutout est à venir',
    comingSoonDesc:
      'Communiquez avec des athlètes célèbres dans le monde entier, en leur envoyant des messages de motivation et de célébration.',
    success: 'Shoutout envoyé avec succès.',
    selectTeamOrAthete: 'Sélectionnez une Équipe ou un Athlète',
    teamOrAthlete: 'Équipe/Athlète',
    writeShoutout: 'Écrivez un message',
    createMatchDayShoutout: 'Créer un cri pour le jour du match',
    matchDayShoutouts: 'Cris le jour du match',
    shoutoutsFromAthletes: 'De la part des athlètes',
    shoutoutsFromFans: 'De la part des fans'
  },
  shop: {
    comingSoon: 'La boutique sera bientôt disponible',
    comingSoonDesc:
      "Des articles de vos athlètes préférés, des billets pour des événements, des offres exclusives et bien d'autres choses encore seront disponibles dans notre boutique confortable. Nous vous informerons bientôt de l'ouverture."
  },
  header: {
    logOutConfirmation:
      "Vous vous êtes déconnecté de votre compte ? Vous pouvez vous connecter ultérieurement en utilisant vos informations d'identification.",
    upgradePlan: 'Plan de mise à niveau'
  },
  post: {
    timestampYear: 'y',
    timestampMonth: 'm',
    timestampWeek: 'w',
    timestampDays: 'd',
    timestampHour: 'h',
    timestampSecond: 's',
    deletePost: 'Supprimer le message',
    editPost: 'Modifier le message',
    reportPost: 'Signaler le poste',
    areYouSure: 'Êtes-vous sûr de vouloir supprimer votre message ?',
    reportingSoon: "Le rapport n'est pas encore disponible. Veuillez revenir plus tard.",
    beingProcessed: 'Cette vidéo est en cours de traitement, veuillez revenir plus tard.'
  },
  billing: {
    billing: 'Facturation',
    settings: 'Paramètres',
    history: "L'histoire",
    billingInformation: 'Informations sur la facturation',
    paymentMethod: 'Mode de paiement',
    addPaymentMethod: 'Ajouter un mode de paiement',
    youNeedToAddMethod: 'Vous devez ajouter un mode de paiement',
    forYourPurches:
      "Vous serez redirigé vers notre application web afin d'ajouter votre méthode de paiement.",
    goToWebApp: "Vers l'application web",
    exp: 'Exp',
    removingCard: 'Cette carte sera retirée',
    sureToRemove: 'Êtes-vous sûr de vouloir supprimer **** {{last4}} ?',
    noPaymentsYet: 'Aucun paiement pour le moment',
    processedPaymentsHere: 'Vous y trouverez la liste des paiements traités.',
    shoutoutTo: 'Shoutout à {{name}}',
    connectWith: 'Connectez-vous en tête-à-tête avec {{name}}',
    connectRefused: 'Connexion individuelle refusée par {{name}}',
    connectCanceledBy: 'Connexion individuelle annulée par {{name}}',
    termsAndConditions:
      "Conformément aux conditions générales, j'accepte que le montant indiqué ci-dessus me soit facturé lors de la confirmation du p4p.",
    swipeRightToPurchase: 'Passer à droite pour acheter',
    subscription: 'Abonnez-vous à {{name}}',
    purchase: 'Achat'
  },
  revenueTarget: {
    none: 'Aucun',
    oneThousand: "Jusqu'à 1 000 $",
    fiveThousand: "Jusqu'à 5 000 $",
    tenThousand: "Jusqu'à 10 000 $",
    hundredThousand: "Jusqu'à 100 000",
    oneMillion: "Jusqu'à 1 000 000 $",
    moreThanMillion: 'Plus de 1 000 000'
  },
  forgotPassword: {
    recoveryEmailSent: 'E-mail de récupération envoyé',
    checkYourInbox:
      'Vérifiez votre boîte de réception (et vos dossiers de spam) pour trouver et suivre les instructions de réinitialisation de votre mot de passe.',
    backToLogin: 'Retour connexion',
    passwordReset: 'Réinitialisation du mot de passe',
    enterEmail:
      "Saisissez l'adresse électronique associée à votre compte et nous vous enverrons les instructions de récupération du mot de passe.",
    sendRecovery: "Envoi d'un courriel de récupération",
    checkEmail: 'Vérifiez votre adresse e-mail',
    noAccount: "Il n'y a pas de compte associé",
    anotherAddress: 'Veuillez essayer une autre adresse.',
    tryAnother: 'Essayez un autre e-mail',
    createNewPassword: 'Créer un nouveau mot de passe',
    doesntMatch: 'Ne correspond pas',
    newPassword: 'nouveau mot de passe',
    resetPassword: 'Réinitialiser le mot de passe',
    passwordRule1: 'Le nouveau mot de passe doit être différent du précédent.',
    passwordRule2: "Au moins 8 caractères - plus il y a de caractères, mieux c'est.",
    passwordRule3: 'Mélange de lettres majuscules et minuscules.',
    passwordRule4: 'Mélange de lettres et de chiffres.',
    passwordRule5: 'Au moins un caractère spécial, par exemple ! @ # ?'
  },
  getTheApp: {
    header: "Téléchargez l'APP playaz4playaz pour votre smartphone",
    setupAccount:
      "Téléchargez l'application playaz4playaz pour votre smartphone afin de configurer votre compte."
  },
  share: {
    repost: 'Republier',
    copyLink: 'Copier le lien',
    viaMessage: 'Partager par message',
    toFb: 'Partager sur Facebook',
    toInst: 'Partager sur Instagram',
    toTwit: 'Partager sur Twitter',
    toWhapp: 'Partager sur WhatsApp',
    toTelg: 'Partager sur Telegram',
    viaEmail: 'Partager par e-mail'
  },
  verification: {
    verifyProfile: 'Vérifier le profil',
    verifyProfile2: 'Vérifier le profil',
    accountNeedsVerification:
      "Votre compte doit être vérifié. Veuillez prendre une photo avec votre carte d'identité à côté de votre visage. Vous pourrez le faire plus tard à partir du profil.",
    needVerification: 'Votre compte doit être vérifié pour participer aux appels individuels.',
    yourProfileVerified: 'Votre profil vérifié',
    verificationRequested: 'Vérification demandée',
    beingVerified:
      "Le profil est vérifié dans les 24 heures. Une fois que c'est fait, vous pouvez vous connecter en tête-à-tête après que le paiement a été effectué.",
    profileVerifiedDescription:
      "Merci d'avoir terminé la vérification. Vous pouvez maintenant sauter dans le tête-à-tête prévu."
  },
  events: {
    shoutouts: 'Salutations',
    livescore: 'Score en direct',
    pictures: 'Photos',
    stats: 'Statistiques',
    noShoutouts: 'Pas encore de commentaires sur cet événement',
    addShoutout: 'Envoyez-en un maintenant pour être le premier à le crier !'
  },
  games: {
    ht: 'Mi-temps',
    ft: 'Dernière heure\n',
    matchday: 'Jour de match {{round}}',
    roundOf16: 'Huitième de finale',
    quarterFinal: 'Quart de finale',
    semiFinal: 'Demi-finale',
    playOff: "Jouer à l'extérieur",
    playoffFinal: 'Finale des éliminatoires',
    final: 'Finale',
    preSeason: 'Pré-saison',
    playOffSemiFinal: 'Demi-finale des éliminatoires',
    wantToShoutout: "Envie d'un coup de gueule ?"
  },
  permissions: {
    permissionsBlocked: 'Permissions bloquées',
    goToYourSettings: 'Veuillez vous rendre dans vos paramètres et activer {{permission}}.',
    openSettings: 'Ouvrir les paramètres',
    camera: 'Appareil photo',
    microphone: 'Microphone',
    gallery: 'Galerie'
  },
  store: {
    suggestedItems: "Suggestion d'articles",
    liked: 'Aimé',
    merchandise: 'Marchandises',
    tickets: 'Billets',
    fromSubscribed: 'Des athlètes abonnés',
    productDetails: 'Détails du produit',
    selectSize: 'Choisir la taille',
    selectStock: 'Sélectionner le type',
    seeSizeGuide: 'Voir le guide des tailles',
    currentBid: 'Offre actuelle',
    placeBid: "Placez l'offre",
    likedProducts: 'Produits appréciés',
    noLiked: "Aucun produit n'a encore été aimé",
    addToCart: 'Ajouter au panier',
    cart: 'Chariot',
    totalCost: 'Coût total : ',
    checkout: 'Passer à la caisse',
    orderSuccessful: 'Commande réussie',
    size: 'Taille',
    price: 'Prix',
    proceedToPayment: 'Procéder au paiement',
    sizeWithDesc: '{{size}} taille',
    clearAll: 'Tout effacer'
  },
  goLive: {
    onlineCount: '{{onlineCount}} abonnés en ligne',
    onlineCountFan: '{{onlineCount}} adeptes en ligne',
    watchingCount: '{{watchingCount}} regarder',
    youAreLive: 'Vous êtes en direct !',
    streamIsFinished: 'Le flux est terminé.',
    live: 'VIVRE',
    end: 'Fin',
    comment: 'Commentaire',
    tapForGoLive: 'Tapez pour mettre en ligne'
  },
  subscribe: {
    monthly: 'Mensuel',
    annual: 'Annuel',
    off: '{{amount}} % de réduction',
    upToOff: "Jusqu'à {{amount}}% de réduction",
    athletesAndTeams: 'Athlètes et équipes',
    subscribeFor: "S'abonner à <strong>{{amount}}\/mois<\/strong>",
    subscriptionSummary: "Résumé de l'abonnement",
    introductoryOffer: 'Offre de lancement',
    annualDiscount: 'Payer 10 mois pour 12 avec la réduction annuelle',
    noResults: "Aucun résultat n'a été trouvé avec les critères correspondants",
    teamFan: 'Fan de {{team}} ?',
    subscribeForTeam: "S'abonner aux athlètes de l'équipe de <strong>{{amount}}\/mois<\/strong>",
    seeAllAthletes: 'Voir tous les athlètes {{number}}',
    subscribeModalTitle: 'Abonnez-vous à vos athlètes et équipes préférés',
    subscribeModalDesc:
      "Profitez du contenu exclusif des athlètes et des équipes. Abonnez-vous aux équipes et bénéficiez d'un accès complet aux joueurs à partir de 5,99 $.",
    athletesToSubscribe: 'Athlètes à inscrire',
    numberAthletes: 'Athlètes {{amount}}',
    cancelSubscription: "Annuler l'abonnement",
    daysLeftInPeriod: '{{montant}} jours restants dans la période en cours',
    sureToCancel: 'Êtes-vous sûr de vouloir annuler votre abonnement ?',
    bundleSquad: '{{name}} escouade',
    remindMeLater: 'Rappelez-moi plus tard'
  },
  americanFootball: {
    quarterback: 'Quart-arrière',
    runningBack: 'Running Back (retour au travail)',
    wideReceiver: 'Récepteur large',
    tightEnd: 'Tight End',
    leftGuard: 'Garde gauche',
    rightGuard: 'Garde droite',
    center: 'Centre',
    leftTackle: 'Manœuvre gauche',
    rightTackle: 'Plaqueur droit',
    noseTackle: 'Palanquée de nez',
    defensiveTackles: 'Plaquages défensifs',
    offensiveTackles: 'Plaquages offensifs',
    offensiveLineman: 'Joueur de ligne offensive',
    middleLineBacker: 'Soutien à la ligne médiane',
    outsideLineBacker: 'Soutien de la ligne extérieure',
    defensiveBack: 'Défenseur',
    flanker: 'Flanker',
    splitEnd: "Fin de l'aventure",
    kicker: 'Botteur',
    punter: 'Pointeur',
    cornerback: 'Cornerback',
    safety: 'Sécurité',
    defensiveEnd: 'Extrémité défensive',
    runningBackHalfback: 'Latéral droit',
    runningBackFullback: 'Latéral droit'
  },
  baseball: {
    centerFielder: 'Joueur de champ central',
    pitcher: 'Lanceur',
    catcher: 'Attrapeur',
    baseman: 'Homme de base',
    shortstop: 'Arrêt-court',
    leftFielder: 'Joueur de champ gauche',
    rightFielder: 'Joueur de champ droit',
    firstBaseman: 'Premier joueur de base',
    secondBaseman: 'Deuxième joueur de base',
    thirdBaseman: 'Troisième base',
    designatedHitter: 'Attaquant désigné'
  },
  basketball: {
    pointGuard: 'Gardien de but',
    shootingGuard: 'Gardien de but',
    smallForward: 'Petit attaquant',
    powerForward: 'Attaquant de puissance',
    center: 'Centre',
    comboGuard: 'Combo Guard',
    wingGuard: "Garde de l'aile",
    pointForward: 'Point de départ',
    comboForward: "Combo vers l'avant"
  },
  cricket: {
    captain: 'Capitaine',
    wicketkeeper: 'Gardien de but',
    slip: 'Slip (glissement)',
    gully: 'Ravine',
    point: 'Point',
    cover: 'Couverture',
    thirdMan: 'Troisième homme',
    fineLeg: 'Jambes fines',
    midWicket: 'Guichet de milieu de terrain',
    midOff: 'Milieu de terrain Off',
    squareLeg: 'Patte carrée'
  },
  soccer: {
    goalkeeper: 'Gardien de but',
    striker: 'Striker',
    centerbackStopper: 'Arrière central (stoppeur)',
    centerbackSweeper: 'Arrière central (balayeur)',
    centerbackQuarterBack: 'Arrière central (quart-arrière)',
    rightFullback: 'Latéral droit',
    leftFullback: 'Latéral gauche',
    centerForward: 'Avant-centre',
    wingers: 'Ailes',
    leftMid: 'Milieu de terrain gauche',
    wideMid: 'Milieu de terrain large',
    rightMid: 'Milieu de terrain droit',
    centerMid: 'Milieu de terrain central',
    attackingMid: 'Milieu offensif',
    defensiveMid: 'Milieu de terrain défensif',
    defensiveMidBallWinner: 'Milieu de terrain défensif (récupérateur de ballons)',
    defensiveMidDeepLyingPlaymaker: 'Milieu de terrain défensif (meneur de jeu en profondeur)',
    boxToBoxMid: 'Milieu de terrain box-to-box',
    wingback: 'Ailier\/arrière',
    false9: 'Faux 9',
    raumdeuter: 'Raumdeuter',
    forward: 'En avant'
  },
  tennis: {
    oneUp: 'One-up',
    oneBack: 'Un dos'
  },
  handball: {
    goalkeeper: 'Gardien de but',
    leftBack: 'Dos gauche',
    centerBack: 'Centre Dos\/Centre',
    rightBack: 'Dos droit',
    leftWinger: 'Ailier gauche',
    centerForward: 'Avance centrale\/Pivot\/Courrier circulaire',
    rightWinger: 'Ailier droit',
    farRight: 'Extrême droite',
    halfRight: 'Demi-droit',
    backCenter: 'Centre arrière',
    frontCenter: 'Centre avant'
  },
  iceHockey: {
    leftDefenseman: 'Défenseur gauche',
    goaltender: 'Gardien de but\/Goalie',
    rightDefenseman: 'Défenseur droit',
    leftWinger: 'Ailier gauche',
    center: 'Centre',
    rightWinger: 'Ailier droit'
  },
  lacrosse: {
    attackmen: 'Attaquants',
    mid: 'Milieu de terrain',
    defensemen: 'Défenseurs',
    goalkeeper: 'Gardien de but'
  },
  polo: {
    lowWingLeftWing: 'Aile basse\/aile gauche',
    lowWingRightWing: 'Aile basse\/aile droite',
    centerHoleSet: 'Ensemble centre\/trou',
    topWingLeftFlat: 'Aile supérieure\/Gauche plate',
    topWingRightFlat: 'Aile supérieure\/plat droit',
    point: 'Point',
    cornerPost: 'Coin\/Poteau',
    middleDefense: 'Milieu\/Défense',
    topDefense: 'Défense supérieure'
  },
  rowing: {
    coxswain: "Maître d'équipage",
    rower: 'Rameur'
  },
  softball: {
    pitcher: 'Lanceur',
    catcher: 'Attrapeur',
    firstBaseman: 'Premier joueur de base',
    secondBaseman: 'Deuxième joueur de base',
    shortstop: 'Arrêt-court',
    thirdBaseman: 'Troisième base',
    leftFielder: 'Joueur de champ gauche',
    centerFielder: 'Joueur de champ central',
    rightFielder: 'Joueur de champ droit'
  },
  rugby: {
    looseheadProp: 'Tight-head Prop',
    hooker: 'Crochet',
    tightheadProp: 'Tight-head Prop',
    lock2ndRow: 'Serrure\/2ème rangée',
    blindSideFlanker: 'Flanker aveugle',
    openSideFlanker: 'Flanker ouvert',
    number8: 'Numéro 8',
    scrumHalf: 'Moitié de la mêlée',
    flyHalf: 'Demi-volant',
    leftWing: 'Aile gauche',
    insideCenter: 'Centre intérieur',
    outsideCenter: 'Centre extérieur',
    rightWing: 'Droite',
    fullback: 'Arrière'
  },
  volleyball: {
    setter: 'Setter',
    outsideHitter: 'Attaquant extérieur',
    middleBlocker: 'Bloqueur moyen',
    libero: 'Libero',
    oppositeHitter: 'Frappeur opposé'
  },
  stories: {
    subscribeTo: "Abonnez-vous pour avoir accès à d'autres articles de {{name}}"
  },
  reports: {
    descriptionPlaceholder: 'Décrivez votre raison...',
    reportingPost: 'Signaler le message de {{name}}',
    reportingShoutout: 'Rapporter le shoutout de {{name}}',
    reportingStory: "Rapporter l'histoire de {{name}}",
    report: 'Rapport'
  },
  error: {
    noNetwork: 'No network connection',
    somethingWentWrong: "Quelque chose n'a pas fonctionné !",
    pleaseTryAgainLater: 'Veuillez réessayer plus tard.'
  },
  requestShoutout: {
    discardChanges: 'Annuler les modifications?',
    selectAthlete: "Sélectionner l'athlète",
    newRequest: 'Nouvelle demande',
    requestAShoutout: 'Demander un salut',
    itsMine: "C'est le mien",
    forSomeoneElse: "Pour quelqu'un d'autre",
    whatIsYourName: 'Quel est votre nom?',
    introduction: 'Présentez-vous',
    selectOcassion: "Sélectionnez l'occasion/la raison",
    birthday: 'Anniversaire (Birthday)',
    anniversary: 'Anniversaire (Anniversary)',
    motivational: 'Motivant',
    mentorship: 'Mentorat',
    gender: 'Genre',
    addInstruction: "Ajouter des instructions (ce que vous voudriez qu'ils disent)",
    deliveryInfo: 'Informations de livraison',
    standard: 'Standard',
    videoDelivered: 'La vidéo sera livrée dans un délai de {{day}} jours',
    requestSent: 'Votre demande a été envoyée!',
    requestConfirmation:
      "Nous venons d'envoyer votre demande de salutations à {{athlete}}. Bien que le délai de réalisation soit de {{day}} jours maximum, nous sommes optimistes quant à une réalisation possible même plus tôt.",
    whoThisFor: "C'est pour qui?",
    standard: 'Standard ({{price}})',
    bookNow: 'Reserve maintenant',
    backToShoutout: 'Retour aux salutations',
    maximum18Chars: 'Maximum 18 caractères',
    maximum200Chars: 'Maximum 200 caractères',
    youCanAdd18Chars: "Vous pouvez taper jusqu'à 18 caractères",
    youCanAdd200Chars: "Vous pouvez taper jusqu'à 200 caractères"
  },
  yourRequests: {
    view: 'Voir',
    yourRequests: 'Vos demandes',
    myShoutoutRequests: 'Mes demandes de salutation',
    shoutoutRequestsFromFans: 'Shoutout Requests from Fans',
    face2faceRequests: 'Demandes face à face',
    all: 'Tous',
    pending: 'En attente',
    completed: 'Complété',
    unfulfilled: 'Non réalisé',
    fromAthletes: 'De la part des athlètes',
    fromFans: 'De la part des fans',
    dayLeft: '{{dayLeft}} Jour restant',
    daysLeft: '{{dayLeft}} Jours restant',
    fulfilledOn: 'Complété le {{date}}',
    unfulfilledOn: 'Non réalisé le {{date}}',
    decline: 'Décliner',
    startRecording: "Commencer l'enregistrement",
    record: 'Enregistrer',
    tapForRecording: 'Appuyez pour enregistrer',
    send: 'Envoyer',
    completeTheRequest: 'Compléter la demande',
    discardChanges: 'Annuler les modifications?',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    awesome: 'Génial!',
    shoutoutSuccessfullySent: 'Votre shoutout a été envoyé avec succès !',
    declineTheRequest: 'Décliner la demande',
    busyConsiderToProfit:
      'Nous comprenons que vous êtes occupé, veuillez envisager de profiter de votre marque lors de la prochaine demande de fan.'
  },
  shoutoutsVideoGallery: {
    fromMe: 'De ma part',
    fromFellowAthletes: 'De la part d’autres athlètes',
    for: 'Pour {{name}}'
  },
  letsChatSports: {
    startChat: 'Start Chat',
    writeTopic: 'Write a topic'
  }
};
